import { Context, ContextInput, DeviceType } from 'bernie-context';

export const isMobileDevice = (context: ContextInput | Context) =>
  (context as ContextInput).device?.type === DeviceType.MOBILE_PHONE || (context as Context).deviceInformation?.mobile;

export const isTabletDevice = (context: ContextInput | Context) =>
  (context as ContextInput).device?.type === DeviceType.MOBILE_TABLET || (context as Context).deviceInformation?.tablet;

export const isMobileOrTabletDevice = (context: ContextInput | Context) =>
  isMobileDevice(context) || isTabletDevice(context);
